/////////////////////// class functions definition
/*global jQuery, $, Kinetic, KeyboardJS,
	WritingTest, parseLinkHash*/

WritingTest.prototype = jQuery.extend( {}, commonGameFunctions, {
//showFluency: true,
gameName: "TestProgram",
linesMoved: 0,
spaceReminderTimer: null,
loadLine: function() {
	var str = "";
	var old_str = "";
	var testText = new Kinetic.Text({
		text: str,
		fontSize: this.g.fontSize,
		fontFamily: (this.fontFamily == 'serif' ? 'Times New Roman' : 'Open Sans, Arial'),
		//fontFamily: 'Open Sans, Arial',
		fontStyle: 'bold'
	});
	while (true) {
		old_str = str;
		if (str !== "") { str += " "; }
		str += this.words[this.currentWord];
		testText.setText(str);
		if (testText.getWidth() <= this.gameRegion.getWidth() - 70) {
			this.currentWord++;
			this.preparedWords--;
		} else {
			break;
		}

		if(this.currentWord > this.words.length - 1 || (this.c.breakLines && this.lineBreaksIndexes.indexOf(this.currentWord) >= 0)){
			old_str = str;
			break;
		}
	}
	// Now we have string with the max length, make line from it
	this.preparedLetters += old_str.length;
	this.lines[this.loadedLines] = old_str;
	if (this.currentWord < this.words.length) {
		this.lines[this.loadedLines] += " "; // space at the end of line
		this.preparedLetters += 1;
	}

	// if the previous line does not end with [space], we add it there (otherwise the space would be missing between the previous and the current line)
	if (this.loadedLines > 0) {
		var previousLine = this.lines[this.loadedLines - 1];
		var lastChar = previousLine[previousLine.length - 1];
		if (lastChar != ' ') {
			this.lines[this.loadedLines - 1] += ' ';
		}
	}

	this.linesStatus[this.loadedLines] = [];
	this.prepareLine(this.loadedLines, -1);
	this.loadedLines++;
	this.preparedLines++;
},

cutWords: function(arr, delimeter){
	var concated = [];
	var indexes = this.lineBreaksIndexes;
	var index = this.currentWord;
	for(var i = 0; i < arr.length; i++){
		var split = arr[i].split(delimeter);
		for(var j = 0; j < split.length; j++){
			concated.push(split[j]);
		}
		index += split.length;
		indexes.push(index);
	}
	this.lineBreaksIndexes = indexes;
	return concated
},

loadWords: function() {
	if(this.waitingForWords) return;
	var t = this;
	this.waitingForWords = true;

	var dataToSend = this.c.wordsSettings;
	dataToSend.timeLimit = this.c.timeLimit;
	dataToSend.gameCategory = this.gameCategory;

	$.ajax({
		dataType: "json",
		cache: false,
		url: this.l.getWordsUrl,
		data: dataToSend,
		async: true
	}).done(function( data ) {
			if (data.status === 'ok') {
				if(t.gamePlaying){
					t.words = t.words.concat(addSpecialCharsToWords(t.cutWords(data.words, ' '), t.c.wordsSettings.newLetters));
					t.preparedWords += t.words.length;
					t.wordSet++;
				} else{
					t.preloadedWords = addSpecialCharsToWords(t.cutWords(data.words, ' '), t.c.wordsSettings.newLetters);
				}
			} else {
				alert(t.t.loadWordsError);
			}
			t.waitingForWords = false;
			if(t.waitingForWordsFunc) t.waitingForWordsFunc();
		});
},

prepareLine: function(index, writed) {
	if (!this.lines[index]) return;
	var str = this.lines[index];

	if(this.linesGroup[index] !== undefined){
		//this.linesColumn.remove(this.linesGroup[index]);
		this.linesGroup[index].destroy();
	}
	this.linesGroup[index] = new Kinetic.Group({
		x: 10,
		y: index * this.g.wordsLineHeight + 10,
		//fill: 'white',
		fired: false
	});
	var rect = new Kinetic.Rect({
		x: 0,
		y: -4,
		width: this.gameRegion.getWidth() - this.linesGroup[index].getX()*2 + 5,
		height: this.g.wordsLineHeight/*,
		fill: 'white'*/
	});
	this.linesGroup[index].add(rect);

	var offsetX = 0;

	var templateText = new Kinetic.Text({
		fontSize: this.g.fontSize,
		fontFamily: (this.fontFamily == 'serif' ? 'Times New Roman' : 'Open Sans, Arial'),
		fontStyle: 'bold'
	});

	// 1. Writed letters - two types, wrong and good
	var lastType = '';
	var lastTextIndex = 0;
	for(var i = 0; i < writed; i++){
		if ((this.linesStatus[index][i] && lastType != 'good')
		|| (!this.linesStatus[index][i] && lastType != 'wrong')) {
			var word = templateText.clone({
				text: str.substr(lastTextIndex, i - lastTextIndex),
				fill: lastType == 'good' ? this.common.colors.text.good : this.common.colors.text.wrong,
				x: offsetX
			});
			lastType = this.linesStatus[index][i] ? 'good' : 'wrong';
			lastTextIndex = i;

			offsetX += word.getTextWidth();
			this.linesGroup[index].add(word);
		}
	}
	// Last type group
	var word = templateText.clone({
		text: str.substr(lastTextIndex, writed - lastTextIndex),
		fill: lastType == 'good' ? this.common.colors.text.good : this.common.colors.text.wrong,
		x: offsetX
	});
	offsetX += word.getTextWidth();
	this.linesGroup[index].add(word);

	// 2. Current char
	if (writed < str.length) {
		var currentChar = templateText.clone({
			text: str.charAt(writed),
			fill: this.common.colors.text.current,
			x: offsetX
		});
		offsetX += currentChar.getTextWidth();
		this.linesGroup[index].add(currentChar);
		this.currentChar = currentChar;
	} 

	// 3. rest
	if (writed < str.length - 1) {
		var text = templateText.clone({
			text: str.substr(writed + 1),
			fill: this.common.colors.text.other,
			x: offsetX
		});
		this.linesGroup[index].add(text);
	}

	this.linesColumn.add(this.linesGroup[index]);

	this.underline.setX(this.currentChar.x() + 10);
	this.underline.setY(this.g.wordsLineHeight * (index - this.linesMoved) + (this.g.fontSize + this.g.underlineOffset));
	this.underline.setWidth(this.currentChar.width());
	this.layers.words_layer.add(this.underline);
	this.underline.setZIndex(20);
	this.layers.words_layer.draw();
},

nextLine: function() {
	while (this.preparedLines < 10 && this.currentWord < this.words.length) {
		this.loadLine();
	}
	this.currentLine += 1;
	if(!this.lines[this.currentLine]) { this.endGame(); }
	this.currentLineWrited = 0;
	if(this.linesGroup[this.currentLine] !== undefined) { this.linesGroup[this.currentLine].destroy(); }
	this.prepareLine(this.currentLine, 0);

	
	// Scroll lines if needed
	var totalLinesVisible = Math.floor(this.g.height / (this.g.wordsLineHeight + 10));	// kolik radku textu se vejde na obrazovku
	var linesUsed = this.currentLine - this.linesMoved;		// kolik opsanych radku se zobrazuje
	var areAllPreparedLinesVisible = this.preparedLines <= totalLinesVisible - linesUsed;
	var areAllWordsPrepared = this.currentWord >= this.words.length;
	var linesToUseBeforeMoving = totalLinesVisible >= 4 ? 2 : 1;

	
	if ((areAllWordsPrepared && areAllPreparedLinesVisible) || linesUsed <= linesToUseBeforeMoving) {
		this.linesColumn.draw();	// Only draw
	} else {
		
		this.linesMoved++;
			
		new Kinetic.Tween({
			node: this.underline,
			duration: 0.1,
			y: this.underline.y() - this.g.wordsLineHeight
		}).play();

		new Kinetic.Tween({
			node: this.linesColumn,
			duration: 0.1,
			y: -this.g.wordsLineHeight*(this.linesMoved)
		}).play();

		this.layers.words_layer.draw();
	}

	this.preparedLines--;
	
},

manageBackspace: function() {
	this.manageLetter('Backspace');
},

manageEnter: function() {
	if ($('#continueGameButton').is(':focus')) {	// hack; pokud je vidět tlačítko "Pokračovat v této hře", enter se chová jako klik na toto tlačítko (což je standard, jen my v PH si chování enteru u hry přepisujeme)
		$('#continueGameButton').click();
		return;
	}
	else {
		this.sayWordAgain();
	}
},

ignoreTimeBetweenWords: function() {

	if (this.currentLetterIndex == 0) {		// prvni pismeno na prvnim radku
		return;
	}

	if (this.currentLineWrited > 0 && this.getPreviousLetter() != ' ') {	// cas odecitame u prvniho pismena na (kteremkoliv) radku a take pokud byla predchozim znakem mezera, jinak ne
		return;
	}

	var timeFromLastStroke = (new Date().getTime()) - this.lastStrokeTime;

	if (timeFromLastStroke > 10000) {
		return;		// uz se odecita cas (skrze this.invalidGameTime)
	}

	this.timeBetweenWords += timeFromLastStroke;
},

manageLetter: function(letter) {
	if (this.gameUnstarted && !this.gamePlaying) {
		if (letter == 'Spacebar') this.startGame();
		return;
	}
	if(!this.gamePlaying) { return; }


	if(letter == 'Spacebar' && $('#continueGameButton').is(':focus')) {
		$('#continueGameButton').click();
		return;
	}

	if(this.gamePaused && letter == 'Spacebar') return;

	clearTimeout(this.spaceReminderTimer);


	if (this.isPlayerVisuallyImpaired) {
		this.ignoreTimeBetweenWords();
	}

	this.processTimeBetweenLetters();


	if(this.c.timeLimit) {
		clearTimeout(this.notWritingTimeout);
		this.notWritingTimeout = null;
		this.endGameIfNotWriting();
	}
	

	letter = letter == 'Spacebar' ? ' ' : letter;

	var currentTime = new Date().getTime();
	var isMistake = letter != this.getCurrentLetter()

	if (isMistake) {
		if (this.allowSounds) {
			this.sounds.error.play();
		}

		var letterWithMistake = this.getCurrentLetter();

		if (this.skipWordOnTypo && this.lastStatus == 'wrong' && letterWithMistake == ' ') {
			// nic (pro nevidome, kdyz jsou na mezere, at se jim nezapocitavaji opakovane chyby, dokud nestisknou mezeru)
		}
		else {

			if (currentTime - this.lastWrongTime > this.c.pauseBetweenErrors || this.typosInARow >= this.c.maxTyposInARow) {
	            app.gameData.captureLetter(letter, this.getCurrentLetter(), isMistake, {lineIndex: this.currentLine, letterIndex: this.currentLineWrited})
				this.results.keystrokes += this.letterToKeystrokes(letter);
				this.linesStatus[this.currentLine][this.currentLineWrited] = false;
				this.lastStatus = 'wrong';
				//this.logProblemWord(this.words[this.currentWord]);
				this.lastWrongTime = currentTime;
				this.typosInARow = 0;
				this.doErrorFlash();
				this.results.mistakes++;
				if (this.livesEnabled) {
					this.removeLive();
				}
				
				if (!this.skipWordOnTypo || this.getCurrentLetter() != ' ') {
					this.currentLineWrited++;
					this.currentLetterIndex++;
				}

				if (this.skipWordOnTypo) {
					// move to the end of the current word (so get either to the space after the word or to the end of the whole text, which means game ends)
					while (this.currentLineWrited < this.lines[this.currentLine].length && this.getCurrentLetter() != ' ') {
						this.currentLineWrited++;
						this.currentLetterIndex++;
					}
				}

			} else {
				this.lastWrongTime = currentTime;
				this.typosInARow++;
				return;
			}
		}

	} else {
        app.gameData.captureLetter(letter, this.getCurrentLetter(), isMistake, {lineIndex: this.currentLine, letterIndex: this.currentLineWrited})
		this.results.keystrokes += this.letterToKeystrokes(letter);
		this.results.good_keystrokes += this.letterToKeystrokes(letter);
		this.lastStatus = 'good';
		this.linesStatus[this.currentLine][this.currentLineWrited] = true;
		this.currentLineWrited++;
		this.currentLetterIndex++;
		this.typosInARow = 0;
		this.lastWrongTime = 0;
	}

	if (this.getPreviousLetter() == ' ') {
		if (!this.skipWordOnTypo || !isMistake) {
			this.wordToWriteIndex++;
		}

		if (!this.readWordsInAdvance) {
			this.say(this.getNextWord(), this.c.wordsSettings.useDictionary != undefined);
		}
	}

	if (this.getCurrentLetter() == ' ') {
		var progress = this.getProgress();
		if (Math.floor(progress / 25) > Math.floor(this.lastProgressValue / 25)) {
			this.playProgressSound(Math.floor(progress / 25));
		}
		this.lastProgressValue = progress;
	

		var t = this;
		if (!this.readWordsInAdvance) {		// u rychleho psani tuhle hlasku nechceme
			this.spaceReminderTimer = setTimeout(function() {
				if (t.gamePaused) {	// pauza, nehlasime
					clearTimeout(t.spaceReminderTimer);
					return false;
				}
				var attrName = isMistake ? 'data-spaceReminderAfterMistakeText' : 'data-spaceReminderText';
				t.sayInfo($('#gameTextForScreenReaders').attr(attrName));
			}, 10000);
		}
	}

	this.prepareLine(this.currentLine, this.currentLineWrited);
	if(this.currentLineWrited == this.lines[this.currentLine].length) {
		this.nextLine();
	} else {
		this.linesGroup[this.currentLine].draw();
	}

	if (isMistake && !this.readWordsInAdvance && this.sayMistakeDetails) { 	// toto je az po volani nextLine(), kde se detekuje, jestli jsme na konci textu a tudiz ma skoncit hra
		var infoText = $('#gameTextForScreenReaders').attr('data-mistakeMadeTest')
				.replace("%mistake%", this.spellLetter(letter, 4))
				.replace("%correct%", this.spellLetter(letterWithMistake, 2));

		if (!this.gameOver) {
			infoText += ' ' + $('#gameTextForScreenReaders').attr('data-spaceToContinue');
		}
		
		this.sayInfo(infoText);
	}

	if (this.readWordsInAdvance && this.shouldReadNextBlock()) {		// z aktuálního bloku zbývá míň písmen, než kolik hráč opíše za vteřinu při své aktuální rychlosti
		this.say(this.getNextBlock(), this.c.wordsSettings.useDictionary != undefined);
	}

	if(this.preparedLines < 8 && this.c.endless) this.loadWords();
},

shouldReadNextBlock: function() {
	// na zacatku necist;
	// 		pro jednoduchost; meli bychom to jeste navazat na this.blockToReadSize nebo upravovat obe tyt konstanty najednou
	if (this.currentLetterIndex < 10 && this.blockToReadSize > 15) {		
		return false;
	}

	var lettersRemainingInCurrentBlock = this.nextBlockEndLetterIndex - this.currentLetterIndex;

	// zbyva uz malo pismen, cist dal
	// 		this.blockToReadSize je tady proto, ze se pocita stejne jako pocet znaku, ktere clovek precte za cas stanoveny pro predstih, s jakym se maji dalsi slova cist (this.timeToReadInAdvance)
	
	var mustRemainAtLeast = Math.ceil(this.getSpeed()/60 * this.timeToReadInAdvance);
	if (lettersRemainingInCurrentBlock < mustRemainAtLeast) {
		return true;
	}
	else {
		return false;
	}

},

getNextBlock: function() {

	if (this.readWordsInAdvance) {

		var block = '';
		var lastAddedWordLength = 0;
		this.recalculateBlockSize();

		this.nextBlockStart = this.wordToReadIndex;
		while (this.shouldAddWordToBlock(block, lastAddedWordLength)) {	// muzeme a musime pridavat do bloku
			block += this.words[this.wordToReadIndex] + ' ';
			lastAddedWordLength = this.words[this.wordToReadIndex].length;
			this.wordToReadIndex++;
		}

		this.nextBlockEndLetterIndex += block.length - 1;
		
		return block.trim() || null;
	}
	else {
		return this.getNextWord();
	}
},


sayWordAgain: function() {

	var isDoubleClick = (new Date().getTime() - this.lastEnterPress < 600);
	this.lastEnterPress = new Date().getTime();

	// opakujeme cokoliv, co je vypsane (i info text, i kdyz ten nehlaskujeme)
	var mustBeSpelled = $('#gameTextForScreenReaders').data('mustBeSpelled');

	if (this.getCurrentLetter() == ' ') {	// jsme-li na mezere, posuneme se na zacatek dalsiho slova
		this.currentLineWrited++;	// posun na dalsi pismeno
		this.currentLetterIndex++;
		this.wordToWriteIndex++;	// posuneme i pocitadlo slov
	}

	// hlaskujeme aktualni slovo a vypisujeme zbytek; nikdy neopakujeme info text 
	this.wordToReadIndex = this.wordToWriteIndex;
	this.nextBlockStart = this.wordToWriteIndex;
	this.nextBlockEndLetterIndex = this.currentLetterIndex;

	// odrolujeme index konce bloku na zacatek aktualniho slova, protoze diky tomu pak getNextBlock() ten index posune na opravdovy konec bloku
	var i = 0;
	while (this.currentLineWrited - i > 0 && this.lines[this.currentLine].charAt(this.currentLineWrited - i) != ' ') {
		i++;
	}

	this.nextBlockEndLetterIndex -= i;


	this.say(this.getNextBlock(), mustBeSpelled, isDoubleClick);

	this.prepareLine(this.currentLine, this.currentLineWrited);		// nutnost, pokud stojime na mezere (posuneme se o znak dopredu a musi se to vykreslit)
},


onGameContinue: function() {
	if (this.getCurrentLetter() == ' ') {	// pokud jsme na mezere, poskocime na zacatek dalsiho slova
		this.currentLineWrited++;	// posun na dalsi pismeno
		this.currentLetterIndex++;
		this.wordToWriteIndex++;	// posuneme i pocitadlo slov
		this.wordToReadIndex = this.wordToWriteIndex;
		this.nextBlockStart = this.wordToWriteIndex;
		this.nextBlockEndLetterIndex = this.currentLetterIndex;
		var nextWord = this.getTextToSay(this.getNextBlock(), this.c.wordsSettings.useDictionary != undefined);
		$('#gameTextForScreenReaders').data('previousText', nextWord);	// maly hack – tvarime se, ze predchozi text pro odecitace bylo nasledujici slovo (na ktere jsme prave poskocili)
	}
	else {	// jinak se vratime na zacatek aktualne opisovaneho slova
		while (this.currentLineWrited > 0 && this.getPreviousLetter() != ' ') {
			this.currentLineWrited--;
			this.currentLetterIndex--;
		}

		if (this.readWordsInAdvance) {
			this.wordToReadIndex = this.wordToWriteIndex;
			this.nextBlockStart = this.wordToWriteIndex;
			this.nextBlockEndLetterIndex = this.currentLetterIndex;
			
			$('#gameTextForScreenReaders').data('previousText', '');		// kvuli setupStartButton(), konkretne $('#continueGameButton').click(...), kde se cte to, co bylo k precteni pred pauzou – pokud to nevymazeme, coz ted presne potrebujeme
			this.say(this.getNextBlock(), this.c.wordsSettings.useDictionary != undefined);
			//$('#gameTextForScreenReaders').data('previousText', nextWord);	// maly hack – tvarime se, ze predchozi text pro odecitace bylo nasledujici slovo (na ktere jsme prave poskocili)
		}
	}

	this.prepareLine(this.currentLine, this.currentLineWrited);
},

getPreviousLetter: function() {
	return this.lines[this.currentLine].charAt(this.currentLineWrited - 1);
},

getCurrentLetter: function() {
	return this.lines[this.currentLine].charAt(this.currentLineWrited);
},

getProgress: function() {
	return Math.round(this.wordToWriteIndex / this.c.wordsSettings.count * 100);
},

getNextWord: function() {
	return this.words[this.wordToWriteIndex] || null;
},

shouldAddWordToBlock: function(block, lastAddedWordLength) {
	if (this.wordToReadIndex >= this.words.length) {
		return false; 	// no more words
	} 

	if (lastAddedWordLength <= 2 && block.length - 1 < this.blockToReadSize * 2) {
		return true;	// last word was short and the block is not too long yet
	}	

	if (block.length - 1 < this.blockToReadSize) {
		return true;	// block is still too short
	}

	return false;
},

getGoodStrokes: function() {
	if (this.isPlayerVisuallyImpaired) {
		return this.results.good_keystrokes - this.wordToWriteIndex;	// good strokes without spaces (we ignore time between spaces)
	}
	else {
		return this.results.good_keystrokes;
	}
},
getAllStrokes: function() {
	if (this.isPlayerVisuallyImpaired) {
		return this.results.keystrokes - this.wordToWriteIndex;			// all strokes without spaces (we ignore time between spaces)
	}
	else {
		return this.results.keystrokes;
	}
},

recalculateBlockSize: function() {
	if (this.getSpeed() > 0) {
		this.blockToReadSize = Math.ceil(this.getSpeed()/60 * this.timeToReadInAdvance);	// block size = pocet uhozu za vterinu (rychlost se pocita v minutach)
	}
},

// METODA getMistakes NAIMPLEMENTOVÁNA V SAMOSTATNÉM MODULU
getMistakes: app.testProgram.getMistakes,

updateBars: function() {

	
	if (!this.gamePlaying || this.gamePaused) return;

	// this.errorRateBarCaption.setText((100 - (Math.round(this.getErrorRate()*10)/10)).toFixed(1)+" %");
	// if (this.c.errorRateLimit != 100) {
	// 	var errorRateBarWidth;
	// 	if (this.getErrorRate() <= this.c.errorRateLimit) {
	// 		errorRateBarWidth = (this.maxBarWidth/2)*this.getErrorRate()/this.c.errorRateLimit;
	// 		this.errorRateBar.setFill(this.g.colors.good);
	// 	} else {
	// 		errorRateBarWidth = (1 + Math.sqrt((this.getErrorRate() - this.c.errorRateLimit)/(100 - this.c.errorRateLimit))) * this.maxBarWidth/2;
	// 		this.errorRateBar.setFill(this.g.colors.wrong);
	// 	}
	// 	new Kinetic.Tween({
	// 		node: this.errorRateBar,
	// 		duration: 0.1,
	// 		width: (errorRateBarWidth > 6 ? errorRateBarWidth : 6)
	// 	}).play();
	// }

	// this.speedBarCaption.setText(Math.round(this.getSpeed())+"/min");
	
	
	
	this.layers.results_layer.draw();
},

logProblemWord: function(word) {
	if (this.problemWords[word] === undefined) {
		this.problemWords[word] = 0;
	}
	this.problemWords[word]++;
},

startGame: function() {

	const stopStartGame = this.onStartGame();
	if(stopStartGame === true) { return; }

	this.hideCursor();

	if(this.c.timeLimit) {
		clearTimeout(this.notWritingTimeout);
		this.notWritingTimeout = null;
		this.endGameIfNotWriting();
	}
	

    app.gameData.captureEvent({name: app.gameData.getEventName("startGame"), game: this.gameName});
	this.gameEndedProperly = false;
	if(this.waitingForWords){
		this.gameStartAttempted = true;
		return;
	}
	var layer = this.layers.message_layer;
	new Kinetic.Tween({
		node: this.layers.message_layer,
		duration: 0.3,
		opacity: 0
	}).play();
	if (isFirefox) this.layers.message_layer.visible(false);

	new Kinetic.Tween({
		node: this.layers.words_layer,
		duration: 0.3,
		opacity: 1
	}).play();
	if (isFirefox) this.layers.words_layer.visible(true);

	this.gamePlaying = true;
	this.gameUnstarted = false;
	this.tooltipsStart();
	this.startTime = new Date().getTime();

	var t = this;
	this.gameTimer = setInterval(function() {
		t.updateBars();
	}, 500);

	if (this.c.timeLimit) {
		this.remainingTimeTimer = setInterval(function() {			

			t.currentTimeCaption.setText(t.formatTime(t.getRemainingTime()));

			if (t.getRemainingTime() <= 0) {
				t.endGame();
			}

		}, 200);
	}

	if(this.publicContestId) {
		this.preventRefreshInPublicContest();
	}

    $('#startGameButton').hide();

    $('#gameFormInput').focus();
	
	this.say(this.getNextBlock(), this.c.wordsSettings.useDictionary != undefined, null, false, 1500);

	this.startWatchingKeyboard();
	
	var resultsToSave = this.getResults(0, 0);
	t.saveResults(resultsToSave);
},
endGame: function(endedForNotPlaying) {

	this.showCursor();

	clearTimeout(this.spaceReminderTimer);

	if(this.c.timeLimit) {
		clearTimeout(this.notWritingTimeout);
		this.notWritingTimeout = null;
	}


	setTimeout(function() {		// zpozdeni, aby rychlym stiskem neprerusil cteni teto instrukce
		t.sayInfo($('#gameTextForScreenReaders').attr('data-gameOverText'));
    }, 2000);

	this.gameEndedProperly = true;
	clearInterval(this.gameTimer);
	clearInterval(this.remainingTimeTimer);
	this.setGameVariablesOnGameEnd();
    app.gameData.captureEvent({name: app.gameData.getEventName("endGame"), game: this.gameName})
    this.stopWatchingKeyboard();

	new Kinetic.Tween({
		node: this.layers.words_layer,
		duration: 0.5,
		opacity: 0.5
	}).play();

	var won = 0;
	var color = 'red';
	this.sweepingLine.setFill(this.common.colors.sweepingLine);
	this.sweepingLine.setShadowColor(this.common.colors.sweepingLine);
	if(endedForNotPlaying != 1) {
		if ((this.lives > 0 || !this.livesEnabled || this.c.endless) && this.getErrorRate() <= this.c.errorRateLimit && this.getSpeed() >= this.c.speedLimit) { 
			won = 1; 
			color = this.g.levelColor; 
			this.sweepingLine.setFill(color);
			this.sweepingLine.setShadowColor(color);
		}
	}
	

	if (this.allowSounds) {
		if (won) {
			this.sounds.victory.play();
		}
		else {
			this.sounds.loss.play();
		}
	}


	

	var t = this;
	var oldY = this.sweepingLine.getY();
	var newY = -5;
	var animationTime = 2000;
	var anim = new Kinetic.Animation(function(frame) {
		var y = oldY + (newY - oldY) * frame.time/animationTime;
		t.sweepingLine.setY(y);
		if (frame.time > animationTime) anim.stop();
		for (index = 0; index < t.linesGroup.length; index++) {
			var line = t.linesGroup[index];
			if (!line.fired) {
				if (line.getY() + t.g.fontSize > y) {
					line.fired = true;
					new Kinetic.Tween({
						node: line,
						duration: 0.2,
						opacity: 0.1,
						onFinish: function() {
							if (isFirefox) line.visible(false);
						}
					}).play();
				}
			}
		}
	}, this.layers.words_layer);
	anim.start();


	var resultsToSave = this.getResults(won)

	var resultsToShow = {
		roundId: this.c.roundId,
		stars: this.getStars(won),
        won: won,
        playerRank: this.getPlayerRank(),
        mistakeCount: this.results.mistakes,
        playerSpeed: this.getSpeed(),
		mistakes: resultsToSave.mistakes,
		gameTypeId: 3,
		time: Math.round(Number(resultsToSave.time)),
	}


	setTimeout(function() {
		if (t.allowFormMode) {
			$('#gameFormInput').blur();
		}

		t.resetGameEnvironment();
		t.showResults(resultsToShow, t);
		t.saveResults(resultsToSave);
	}, animationTime);


	this.onEndGame();
},

pauseGame: function() {
	
	if (true /*this.gameOver || !this.gamePlaying || !this.allowPause*/) { return; }

	var index;
	if (this.gamePaused) {
		// Action: resume
		if(this.c.timeLimit) {
			this.endGameIfNotWriting();
		}

		this.linesColumn.setOpacity(1);
		if (isFirefox) this.linesColumn.visible(true);
		if (isFirefox) this.underline.visible(true);
		this.layers.words_layer.draw();
	} else {
		// Action: pause
		if(this.c.timeLimit) {
			clearTimeout(this.notWritingTimeout);
			this.notWritingTimeout = null;
		}

		this.linesColumn.setOpacity(0.2);
		if (isFirefox) this.linesColumn.visible(false);
		if (isFirefox) this.underline.visible(false);
		this.layers.words_layer.draw();
	}

	this.genericPauseGame();
},

printProblemWords: function() {
	var string = '';
	var key;
	for(key in this.problemWords) { string = string+' '+key+'('+this.problemWords[key]+')'; }
	return string;
},

wordsInit: function(){
	this.lineBreaksIndexes = [];
	this.words = this.words.concat(this.cutWords(this.preloadedWords, ' '));
	this.preparedWords += this.preloadedWords.length;
	this.preloadedWords = [];

	if (!this.gameRestarted && !this.hasCustomText) {
		this.words = addSpecialCharsToWords(this.words, this.c.wordsSettings.newLetters);
	}
},

draw: function() {
	Kinetic.pixelRatio = 1;	// fix for zoom-out in browser

	this.wordsInit();
	this.soundsInit();
	


	this.firstMove = true;
	this.underline = new Kinetic.Rect({
		stroke: this.common.colors.text.current,
		height: 1.5
	});
	this.stage = new Kinetic.Stage({
		container: this.containerName,
		width: this.g.width,
		height: this.g.height
	});
	this.layers = { };

	this.setKeyboard({
		'letter': this.manageLetter,
		'specialLetters': { },
		'specialKeys': {
			'Enter': this.manageEnter,
			'Esc': this.pauseGame,
			//'Backspace': this.manageBackspace,
			'Spacebar': this.manageLetter
		},
		'preventPropagation': [ 'Backspace', 'Esc', 'Spacebar', 'Enter' ],
		'allowFormMode': this.allowFormMode
	});


	this.layers.background_layer = new Kinetic.Layer();

	var allBackground = new Kinetic.Rect({
		width: this.stage.getWidth(),
		height: this.stage.getHeight(),
		fill: this.g.allBackgroundColor,
		cornerRadius: 5
	});

	this.errorFlash = allBackground.clone({
		fill: 'red',
		opacity: 0
	});



	this.layers.background_layer
		.add(allBackground)
		.add(this.errorFlash);
	this.stage.add(this.layers.background_layer);


	this.layers.words_layer = new Kinetic.Layer({
		opacity: 0,
		//fillStyle: "rgba(255, 0, 0, 0.1)",
		y: this.g.headerHeight,
		height: this.stage.getHeight() - this.g.headerHeight
	});
	if (isFirefox) this.layers.words_layer.visible(false);

	this.gameRegion = new Kinetic.Rect({
		x: 0,
		width: this.stage.getWidth(),
		height: this.layers.words_layer.getHeight()
	});

	this.linesColumn = new Kinetic.Group({
		y: 5
	});

	this.sweepingLine = this.gameRegion.clone({
		y: this.layers.words_layer.getHeight() + 7,
		height: 3,
		fill: this.common.colors.sweepingLine,
		shadowColor: this.common.colors.sweepingLine,
		shadowOffset: {x:0, y:2},
		shadowBlur: 7
	});

	this.layers.words_layer
		.add(this.gameRegion)
		.add(this.linesColumn)
		.add(this.sweepingLine);
	this.stage.add(this.layers.words_layer);

	var headerWhiteBackground = new Kinetic.Rect({
		width: this.stage.getWidth(),
		height: this.g.headerHeight,
		fill: this.g.allBackgroundColor,
		opacity: 1,
	});
	var headerBackground = new Kinetic.Rect({
		width: this.stage.getWidth(),
		height: this.g.headerHeight,
		fill: this.g.backgroundColor,
		opacity: this.g.opacity
	});

	this.layers.header_layer = new Kinetic.Layer();

	this.layers.header_layer.add(headerWhiteBackground);
	this.layers.header_layer.add(headerBackground);

	this.stage.add(this.layers.header_layer);

	this.layers.results_layer = new Kinetic.Layer({
		height: this.g.headerHeight,
		width: this.stage.getWidth()
	});

	this.maxBarWidth = this.layers.results_layer.getWidth()/5;

	var caption1 = new Kinetic.Text({
		//x: 15 + (this.c.speedLimit == 0 ? this.maxBarWidth/2  : 0),
		x: 170 + this.maxBarWidth/2,
		y: 15,
		text: this.t.results.speed+':',
		fontFamily: 'Open Sans, Arial',
		fontStyle: 'bold',
		fontSize: 18,
		fill: testCaptionTextColor
	});
	var rect1 = new Kinetic.Rect({
		x: caption1.getX() + caption1.getWidth() - 5,
		y: 10,
		stroke: 'white',
		cornerRadius: 5,
		strokeWidth: 1,
		width: this.layers.results_layer.getWidth()/5,
		height: caption1.getHeight(),
		shadowColor: this.common.colors.black,
		shadowBlur: 10,
		shadowOffset: [10, 10],
		shadowOpacity: 0.4
	});
	var caption2 = caption1.clone({
		//x: this.layers.results_layer.getWidth()/2 + (this.c.errorRateLimit == 100 ? this.maxBarWidth/2  : 0),
		x: 470,
		text: this.t.results.accuracy+':'
	});
	var rect2 = rect1.clone({
		x: caption2.getX() + caption2.getWidth() - 5
	});

	// var limitLine1 = new Kinetic.Line({
	// 	points: [rect1.getWidth()/2, rect1.getHeight(), rect1.getWidth()/2, 0],
	// 	stroke: 'white',
	// 	strokeWidth: 1
	// });
	// var limitLine2 = limitLine1.clone();
	// limitLine1.move({x: rect1.getX(), y: rect1.getY()});
	// limitLine2.move({x: rect2.getX(), y: rect2.getY()});

	// this.speedBar = new Kinetic.Rect({
	// 	x: rect1.getX() + 200,
	// 	y: rect1.getY(),
	// 	cornerRadius: 5,
	// 	width: this.maxBarWidth*0.5,
	// 	height: caption1.getHeight(),
	// 	fill: this.g.colors.good
	// });

	// this.errorRateBar = this.speedBar.clone({
	// 	x: rect2.getX(),
	// 	width: this.maxBarWidth*0.5
	// });
	// this.speedBarCaption = caption1.clone({
	// 	//x: 20 + rect1.getX() + (this.c.speedLimit != 0 ? rect1.getWidth() : 0),
	// 	x: 20 + rect1.getX(),
	// 	text: "0/min"
	// });
	// this.errorRateBarCaption = caption1.clone({
	// 	x: 20 + rect2.getX() + (this.c.errorRateLimit != 100 ? rect2.getWidth() : 0),
	// 	text: "100.0 %"
	// });

	
	// var cap10 = new Kinetic.Text({
	// 	x: rect1.getX() - 5,
	// 	y: rect1.getY() + rect1.getHeight() + 5,
	// 	fontSize: 14,
	// 	fontFamily: 'Open Sans, Arial',
	// 	fontStyle: 'bold',
	// 	fill: "white",
	// 	text: "0"
	// });
	// var cap11 = cap10.clone({ x: rect1.getX() + rect1.getWidth()/2 - 7, text: this.c.speedLimit });
	// var cap12 = cap10.clone({ x: rect1.getX() + rect1.getWidth() - 5, text: "∞" });
	// var cap20 = cap10.clone({ x: rect2.getX()- 7, text: "0%" });
	// var cap21 = cap10.clone({ x: rect2.getX() + rect2.getWidth()/2 - 7, text: this.c.errorRateLimit+"%" });
	// var cap22 = cap10.clone({ x: rect2.getX() + rect2.getWidth() - 5, text: "∞" });

	// if (this.showMetricsDuringGame) {
	// 	this.layers.results_layer.add(caption1).add(caption2);
	// 	this.layers.results_layer.add(this.errorRateBarCaption).add(this.speedBarCaption);
	// }

	if (this.c.timeLimit) {
		this.currentTimeCaption = caption1.clone({
			x: this.g.width - 70,
			text: this.formatTime(this.c.timeLimit)
		});

		this.layers.results_layer.add(this.currentTimeCaption);
	}



	this.stage.add(this.layers.results_layer);

	this.layers.waitingForWordsLayer = new Kinetic.Layer({
		x: 0,
		y: 0,
		width: this.stage.getWidth(),
		height: this.stage.getHeight()
	});
	this.waitingForWordsText = new Kinetic.Text({
		y: 220,
		x: 320,
		text: 'Načítám nová slova...',
		fontFamily: 'Open Sans, Arial',
		fontStyle: 'bold',
		fontSize: 14,
		fill: 'orange',
		opacity: 0,
	});
	if (isFirefox) this.waitingForWordsText.visible(false);
	this.layers.waitingForWordsLayer.add(this.waitingForWordsText);
	this.stage.add(this.layers.waitingForWordsLayer);

	if (this.livesEnabled) {
		this.addLivesLayer();
		this.layers.lives_layer.setY(5).draw();
	}

	// Tooltips start
		// tooltips here
	this.tooltipsDraw();
	// Tooltips end


	
	if(!this.needToBuyFullVersion) { this.addMessageLayer(); } 
	else { this.showBuyFullVersionInfo(); }


	this.addPauseLayer();
	//And start with the first line
	//this.loadWords();
	this.removeStartLives();
	if(this.waitingForWordsMessageDisplayed) return;
	if(this.waitingForWords){
		this.waitingForWordsText.setOpacity(1);
		if (isFirefox) this.waitingForWordsText.visible(true);
		this.layers.waitingForWordsLayer.draw();
		this.waitingForWordsMessageDisplayed = true;
		var t = this;
		this.waitingForWordsFunc = function(){
			t.waitingForWordsText.setOpacity(0);
			if (isFirefox) this.waitingForWordsText.visible(false);
			t.layers.waitingForWordsLayer.draw();
			t.waitingForWordsMessageDisplayed = false;
			t.wordsInit();
			t.nextLine();
			if(t.gameStartAttempted) {
				t.gameStartAttempted = false;
				t.startGame();
			}
		}
	}
	else this.nextLine();

	if (this.publicContestId !== null) {
		var textToSay = $('#gameTextForScreenReaders').attr('data-instructionsContest');
	}
	else {
		var textToSay = $('#gameTextForScreenReaders').attr('data-textPrefix') 
					+ ' ' + $('#gameTextForScreenReaders').attr('data-instructionsTest') 
					+ ' ' + $('#gameTextForScreenReaders').attr('data-originalText') 
					+ ' ' + this.getAccessKeyShortcut('J')
					+ '.';		
	}

	this.sayInfo(textToSay);

	this.setupStartButton();
},


restartGame: function() {


	//override game restart in public contest - we need to reload texts and other stuff and this is the easiest way
	if(this.publicContestId) 
	{
		if(this.publicContestPlayerLives == 1) {
			return;
		}

		restartLink = $('.link-restartGame.blue').attr('href');
		this.restartInPublicContest(restartLink);
		return;
	}

	
	this.gameRestarted = true;
	this.resetGameEnvironment();
	this.resetGameVariables();
	this.reloadAfterPlayTexts();
	this.reloadPlayerXpInfo();
	this.lineBreaksIndexes = [];
	this.currentLine = -1;
	this.currentTime = 0;
	this.currentLineWrited = 0;
	this.currentLetterIndex = 0;
	this.currentWord = 0;
	this.wordToWriteIndex = 0;
	this.wordToReadIndex = 0;
	this.lastWrongTime = 0;
	this.typosInARow = 0;
	this.lines = [];
	this.linesGroup = [];
	this.linesStatus = [];
	this.linesMoved = 0;
	this.loadedLines = 0;
	this.preparedLetters = 0;
	this.preparedLines = 0;
	this.blockToReadSize = 20;
	this.nextBlockStart = 0;

	if (this.hasCustomText) {
		this.preparedWords = this.words.length;
	}
	else {
		this.preparedWords = 0;
		this.wordSet = 0;
		this.words = [];
		this.loadWords();
	}

	this.draw();

	$('#gameFormInput').val('');
}

}); /////////////////////// end of the class functions definition
